module.exports = __webpack_public_path__ + "img/voice-icon11.05d98fe.png";